<div class="flex flex-col w-full">
  @if (searchable) {
    <div class="flex w-full mt-2">
      <nrc-search
        class="w-full"
        [placeholder]="placeholder"
        [isCollapsible]="false"
        [borderRadius]="'top'"
        (searchEvent)="onSearchChange($event)"
      />
    </div>
  }

  @if (showSelectAll && filteredItems().length > 0) {
    <div class="flex items-center px-3.5 pb-2 border-b border-white/10">
      <nrc-checkbox
        [checkStatus]="isEveryFilteredItemSelected() ? 'checked' : (isSomeButNotEveryFilteredItemSelected() ? 'semi-checked' : 'unchecked')"
        (clickEvent)="toggleAll()"
      />
      <span
        class="ml-2 text-sm text-gray-400 cursor-pointer"
        tabindex="0"
        (click)="toggleAll()"
        (keydown.enter)="toggleAll()"
        (keydown.space)="$event.preventDefault(); toggleAll()"
      >
        {{ isEveryFilteredItemSelected() ? 'Deselect All' : 'Select All' }}
      </span>
    </div>
  }

  <table class="flex w-full flex-col overflow-auto max-h-[45vh] scrollbar scrollbar-thumb-rounded-full scrollbar-thumb-[#6b7280] scrollbar-track-rounded-full scrollbar-corner-rounded-sm scrollbar-w-1.5 bg-white/10 shadow-[0_6px_14px_#161F2133] rounded-b-md">
    <tbody class="flex flex-col w-full">
      @if (filteredItems().length === 0) {
        <tr class="flex w-full justify-center items-center h-20">
          <td class="text-gray-400 text-sm">{{ emptyMessage }}</td>
        </tr>
      }

      @for (item of filteredItems(); track item.id) {
        <tr
          class="group flex w-full hover:bg-white/5 border-y border-white/10 cursor-pointer last:border-b-0 h-12 items-center"
        >
          <td>
            <nrc-checkbox
              [checkStatus]="item.isSelected ? 'checked' : 'unchecked'"
              (clickEvent)="toggleItem(item.id)"
            />
          </td>
          <td
            class="flex w-full min-w-60 justify-start items-center"
            (click)="toggleItem(item.id)"
          >
            {{ item.label }}
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
